import NavBar from '@/components/NavBar'
import { Container, Content } from './style'

export const JobRoleFormLayout: React.FC = ({ children }) => (
  <Container>
    <NavBar />
    <Content>{children}</Content>
  </Container>
)

export default JobRoleFormLayout
